import React, { useContext } from 'react';

import { Context } from '@store/store';
import ShowSpeechDropdownButton from '@components/control-bar/show-speech-dropdown-button';
import ToggleBookmarkButton from '@components/control-bar/toggle-bookmark-button';

import ShowSettingsDropdownButton from '@components/control-bar/show-settings-dropdown-button';
import { StyledControlBar, LeftPanel, RightPanel } from './control-bar.styles';
import ShowHamburgerMenuButton from './show-hamburger-menu-button';
import CurrentPageSelect from './current-page-select';
import ToggleBookToShelf from '@components/control-bar/toggle-book-to-shelf-button';
import SearchButton from '@components/control-bar/search-button';

const ControlBar = ({ bookId }) => {
  const [state] = useContext(Context);

  return (
    <StyledControlBar>
      <LeftPanel>
        <ShowHamburgerMenuButton />
        <CurrentPageSelect />
        <span style={{ color: '#7C7C7C' }}>&nbsp;/ {state.pagesCount}</span>
      </LeftPanel>
      <RightPanel>
        {[8888, 12809, 120169].includes(bookId) && <ShowSpeechDropdownButton isMobile />}
        {state.efedNoAuth ? null : (
          <>
            <ToggleBookmarkButton isMobile />
            <ToggleBookToShelf isMobile />
          </>
        )}
        <SearchButton isMobile />
        <ShowSettingsDropdownButton bookId={bookId} isMobile />
      </RightPanel>
    </StyledControlBar>
  );
};

export default ControlBar;
